<template>
	<v-container>
		<v-row>
			<v-col class="text-center" cols="12">
				<div class="headline primary--text">TeleRetina - My Profile</div>
			</v-col>

			<v-col cols="12">
				<v-card :loading="loading">
					<v-card-text class="py-0">
						<v-form v-model="valid">
							<v-row justify="center" dense>
								<v-col cols="12">
									<v-row align="center" dense>
										<v-col cols="auto">
											<span class="black--text title">{{ name }}</span>
										</v-col>
										<v-col class="auto">
											<span>({{ gender }})</span>
										</v-col>
										<v-spacer></v-spacer>
										<v-col cols="auto">
											<span>
												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn icon v-on="on" @click="editProfile">
															<v-icon color="primary">mdi-pen</v-icon>
														</v-btn>
													</template>

													<span>Edit Profile</span>
												</v-tooltip>

												<v-tooltip bottom>
													<template v-slot:activator="{ on }">
														<v-btn icon v-on="on" @click="showResetPassword">
															<v-icon color="secondary">mdi-key</v-icon>
														</v-btn>
													</template>

													<span>Reset Password</span>
												</v-tooltip>
											</span>
										</v-col>
									</v-row>
								</v-col>

								<v-col cols="12">
									<v-row dense>
										<v-col cols="auto">
											<span class="black--text">{{ clinicId }}</span>
										</v-col>
										<v-col cols="auto">
											<span>({{ userType }})</span>
										</v-col>
										<v-spacer></v-spacer>
									</v-row>
								</v-col>

								<v-col cols="12">
									<v-row dense>
										<v-col cols="auto">
											<span class="black--text">{{ patientId }}</span>
										</v-col>
										<v-spacer></v-spacer>
										<v-col cols="auto">
											<span>{{ nationality | showNationality(nationalities) }}</span>
										</v-col>
									</v-row>
								</v-col>

								<v-col cols="12">
									<v-row dense>
										<v-col cols="auto">
											<span class="black--text">{{ cellphone }}</span>
										</v-col>
										<v-spacer></v-spacer>
										<v-col cols="auto">
											<span>{{ email }}</span>
										</v-col>
									</v-row>
								</v-col>

								<v-col cols="12">
									<v-row dense>
										<v-col cols="auto">
											<span class="black--text">{{ date }}</span>
										</v-col>
										<v-col cols="auto">
											<span>({{ age }})</span>
										</v-col>
										<v-spacer></v-spacer>
									</v-row>
								</v-col>

								<v-col cols="12">
									<div class="headline black--text">Last 10 actions</div>
								</v-col>

								<v-col cols="12">
									<v-data-table :headers="headers" :items="items" hide-default-footer class="elevation-1"></v-data-table>
								</v-col>

								<v-col cols="12" class="pt-4 text-center">
									<v-btn color="primary" class="text-none" rounded @click="goHome">Return</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="resetPasswordModal" persistent max-width="290">
			<v-card>
				<v-card-title class="headline">Reset Password</v-card-title>
				<v-card-text>
					<v-text-field
						v-model="password"
						label="New Password"
						:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showPassword ? 'password' : 'text'"
						:rules="[rules.required, rules.password]"
						@click:append="() => (showPassword = !showPassword)"
						@keydown.enter="login"
					></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						class="text-none"
						color="error"
						text
						:disabled="loading"
						@click.native="resetPasswordModal = false"
					>
						<template>Close</template>
					</v-btn>
					<v-btn class="text-none" color="primary" :loading="loading" @click.native="resetPassword">
						<template>Reset</template>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
const axios = require("axios");

export default {
	filters: {
		showNationality(nationality, nationalities) {
			if (nationality == null || nationalities.length == 0) {
				return "...";
			}

			return nationalities.filter(nat => nat.id == nationality)[0]
				.description;
		}
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/rules-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/user-types-mixin").default
	],
	data: () => ({
		age: null,
		patientId: null,
		name: null,
		phone: null,
		cellphone: null,
		email: null,
		gender: null,
		nationality: null,
		nationalities: [],
		userType: null,
		clinicId: null,
		loading: true,
		valid: false,
		headers: [
			{
				text: "#",
				align: "left",
				value: "id",
				sortable: false
			},
			{
				text: "Action Type",
				align: "left",
				value: "type",
				sortable: false
			},
			{
				text: "Description",
				align: "left",
				value: "desc",
				sortable: false
			},
			{
				text: "Data/Time",
				align: "center",
				value: "datetime",
				sortable: false
			}
		],
		items: [],
		date: null,
		resetPasswordModal: false,
		password: "",
		showPassword: true
	}),
	watch: {
		menu(val) {
			val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
		},
		date() {
			this.setAge(this.date);
		}
	},
	mounted() {
		this.getPatientInfo();

		this.getNationalities();
	},
	methods: {
		getNationalities() {
			const url = this.BACKEND_URL + "/api/allNationalities";

			let thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						console.log(response.data);
						thisVue.nationalities = response.data;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		getPatientInfo() {
			var id = this.$store.state.userInfo.nationalId;
			this.patientId = id;

			const url = this.BACKEND_URL + "/api/getUserById/" + id;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						thisVue.loading = false;
						console.log("200");
						console.log(response.data);
						var user = response.data;
						setTimeout(() => {
							thisVue.name =
								user.FirstName +
								" " +
								user.FatherName +
								" " +
								user.FamilyName;

							thisVue.date = user.birth;
							thisVue.phone = user.phone;
							thisVue.cellphone = user.cellphone;
							thisVue.email = user.email;
							thisVue.gender = user.gender;
							thisVue.nationality = user.Nationality;

							thisVue.clinicId = user.Clinic;
							thisVue.userType = thisVue.getUserTypeById(
								user.UserType
							);

							thisVue.setAge(user.birth);
						}, 50);
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		save(date) {
			this.$refs.menu.save(date);
		},
		setAge(dateString) {
			var today = new Date();
			var birthDate = new Date(dateString);
			var age = today.getFullYear() - birthDate.getFullYear();
			var m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			this.age = age;
		},
		goHome() {
			this.$router.push("/dashboard/home");
		},
		editProfile() {
			this.$router.push("/dashboard/my-profile/modify");
		},
		showResetPassword() {
			this.resetPasswordModal = true;
		},
		resetPassword() {
			const url = this.BACKEND_URL + "/api/updateUser";

			var data = new FormData();

			data.append("nationalId", this.$store.state.userInfo.nationalId);
			data.append("password", this.password);

			var token = this.getBackendToken();
			data.append("token", token);

			let thisVue = this;
			let config = {};

			axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						console.log("200");
						thisVue.$store.commit("pushNotification", {
							message: "Password updated"
						});
						thisVue.resetPasswordModal = false;
					}
				})
				.catch(error => {
					thisVue.$store.commit("pushNotification", {
						message: error.response.data.message
					});

					console.error(error);
				});
		}
	}
};
</script>

<style>
.v-input--selection-controls:not(.v-input--) .v-input__slot,
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
	margin-bottom: 0;
}
.v-input--checkbox,
.v-input--radio-group {
	margin-top: 0;
	margin-bottom: 0;
}
</style>
